export const userActionType = {
  set_CURRENT_USER: "SET_CURRENT_USER",

  //? get me endpoint
  LOAD_USER_REQUEST: "LOAD_USER_REQUEST",
  LOAD_USER_SUCCESS: "LOAD_USER_SUCCESS",
  LOAD_USER_FAIL: "LOAD_USER_FAIL",
};
